import { ResultOf } from 'gql.tada';
import { gql } from '../../modes/common/gql';

export const ACTIVITY_ITEM_FIELDS = gql(
  `fragment ActivityItemFields on ActivityItem {
    __typename
    id
    read
    dismissed
    followUp
    time
    title
    body
    actionPath
  }`
);

export const GET_ACTIVITY_FEED = gql(
  `query GetActivityFeed($limit: Int, $after: BigInt) {
    activityFeed(limit: $limit, after: $after) {
      totalCount
      unreadCount
      items {
        ...ActivityItemFields
      }
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const MARK_NOTIFICATION_READ = gql(
  `mutation MarkNotificationRead($notificationId: ID!) {
    markNotificationRead(notificationId: $notificationId) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const MARK_NOTIFICATION_UNREAD = gql(
  `mutation MarkNotificationUnread($notificationId: ID!) {
    markNotificationUnread(notificationId: $notificationId) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const MARK_AS_FOLLOW_UP = gql(
  `mutation MarkAsFollowUp($notificationId: ID!) {
    markAsFollowUp(notificationId: $notificationId) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const UNMARK_AS_FOLLOW_UP = gql(
  `mutation UnMarkAsFollowUp($notificationId: ID!) {
    unMarkAsFollowUp(notificationId: $notificationId) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const DISMISS_NOTIFICATION = gql(
  `mutation DismissNotification($notificationId: ID!) {
    dismissNotification(notificationId: $notificationId) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const UNDISMISS_NOTIFICATION = gql(
  `mutation UndismissNotification($notificationId: ID!) {
    undismissNotification(notificationId: $notificationId) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

export const GET_ACTIVITY_ITEM_IDS = gql(
  `query GetActivityItemIds(
    $where: JSON
    $limit: Int
    $offset: Int
    $unreadOnly: Boolean
    $includeDismissed: Boolean
    $orderBy: [ColumnOrder]
  ) {
    activityItems(
      where: $where
      limit: $limit
      offset: $offset
      unreadOnly: $unreadOnly
      includeDismissed: $includeDismissed
      orderBy: $orderBy
    ) {
      id
    }
  }`
);

export const GET_ACTIVITY_ITEMS = gql(
  `query GetActivityItems(
    $where: JSON
    $limit: Int
    $offset: Int
    $unreadOnly: Boolean
    $includeDismissed: Boolean
    $orderBy: [ColumnOrder]
  ) {
    activityItems(
      where: $where
      limit: $limit
      offset: $offset
      unreadOnly: $unreadOnly
      includeDismissed: $includeDismissed
      orderBy: $orderBy
    ) {
      ...ActivityItemFields
    }
  }`,
  [ACTIVITY_ITEM_FIELDS]
);

type GetActivityFeedQuery = ResultOf<typeof GET_ACTIVITY_FEED>;
type GetActivityItemsQuery = ResultOf<typeof GET_ACTIVITY_ITEMS>;

export type ActivityFeedItem =
  GetActivityFeedQuery['activityFeed']['items'][number];
export type ActivityListItem = GetActivityItemsQuery['activityItems'][number];
